import { useMemo, useSyncExternalStore } from 'react';
import { getPersona, setPersona, subscribePersona } from './personaStore.js';

/**
 * TODO(CT-3900 / ARP-804): frontend RBAC is NOT implemented. packages/auth exposes
 * no permissions and the shell hardcodes isAdmin: true (TopNav.jsx:58). Until ARP-804
 * defines the token claim (or the active-workspace permissions endpoint), the role is
 * driven by the DEMO persona store (personaStore.js) — a mock affordance so testers can
 * preview the end-user experience. When ARP-804 lands, only THIS file changes (read the
 * real role) and the demo store/toggle are removed. No domain component should read roles
 * or claims on its own.
 */
export const useIntegrationsPermissions = () => {
  const persona = useSyncExternalStore(subscribePersona, getPersona, getPersona);
  return useMemo(() => ({ canManageIntegrations: persona === 'admin' }), [persona]);
};

/**
 * Demo persona control (CT-4203). Returns the current persona and a setter, backed by
 * the same store `useIntegrationsPermissions` reads. Used by the demo toggle only —
 * removed with RBAC (CT-3900).
 */
export const usePersona = () => {
  const persona = useSyncExternalStore(subscribePersona, getPersona, getPersona);
  return { persona, setPersona };
};
